import { render, staticRenderFns } from "./ScoreChangeLogList.vue?vue&type=template&id=0abcfd5d&"
import script from "./ScoreChangeLogList.vue?vue&type=script&lang=ts&"
export * from "./ScoreChangeLogList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports